module.exports = __webpack_public_path__ + "img/plate_parked.c15c613c.svg";